import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

interface IDomain {
    id: number;
    name: string;
}

export const ListDomainSlice = createSlice({
    name: "ListDomainSlice",
    initialState: {} as IReduxState<string[]>,
    reducers: {
        listDomain: (state) => {
            state.isLoading = true;
        },
        successListDomain: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
        failureListDomain: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
    },
});

export const { failureListDomain, listDomain, successListDomain } =
    ListDomainSlice.actions;

export default ListDomainSlice.reducer;
